module.exports = new __parcel__URL__("select-trello-board.963953c7.svg").toString();